/**
 * @generated SignedSource<<ddc3784fefd4404f0ca42546aeb56376>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpExhibitionNoteRichText_note$data = {
  readonly content: string | null;
  readonly " $fragmentType": "NftPdpExhibitionNoteRichText_note";
};
export type NftPdpExhibitionNoteRichText_note$key = {
  readonly " $data"?: NftPdpExhibitionNoteRichText_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteRichText_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpExhibitionNoteRichText_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "NftExhibitionNoteRichTextContent",
  "abstractKey": null
};

(node as any).hash = "af17b205ae8683e82c13302bfa1219ea";

export default node;
